import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import ApiLogHistory from "../../../common/ApiLogHistory";

import useAxios from "../../../../hooks/useAxios";
import { __getUpdateNumberLog } from "../../../../api/sim";
import { getChipColor } from "../../../../constants/value";

const TmobilejUpdateNumberHistory = (props) => {
  const [updateNumberHistory, setUpdateNumberHistory] = useState([]);
  const { update_number_id } = useParams();

  const [response, call, loading] = useAxios({
    ...__getUpdateNumberLog(update_number_id),
  });

  useEffect(() => {
    if (response && response.status) {
      setUpdateNumberHistory(response.data);
    }
  }, [response]);

  useEffect(() => {
    call();
  }, []);

  return loading ? (
    <Title content="Please wait..." variant="subtitle2" gutterBottom />
  ) : (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          Update Number Log
        </Typography>
      </Box>

      {response && updateNumberHistory.data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">MSISDN</TableCell>
                    <TableCell align="left">Batch ID</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Webhook</TableCell>
                    <TableCell align="left">Webhook ID</TableCell>
                    <TableCell align="left">Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">
                      {updateNumberHistory.data.msisdn}
                    </TableCell>
                    <TableCell align="left">
                      <Link
                        underline="none"
                        to={`/tmobilej/update_number/batch/${updateNumberHistory.data.batch_id}`}
                      >
                        {updateNumberHistory.data.batch_id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={updateNumberHistory.data.status}
                        size="small"
                        color={getChipColor(updateNumberHistory.data.status)}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {updateNumberHistory.data.webhook}
                    </TableCell>
                    <TableCell align="left">
                      {updateNumberHistory.data.webhook_id}
                    </TableCell>
                    <TableCell align="left">
                      {updateNumberHistory.data.last_updated &&
                        `${format(
                          new Date(updateNumberHistory.data.last_updated),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ApiLogHistory data={updateNumberHistory.history.data} />
        </>
      ) : (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default TmobilejUpdateNumberHistory;
